<template>

    <div class="page p-patient_add">
        <the-dashboard-heading>
            <h2>
                <router-link :to="{ name: 'Patients' }">Pacjenci</router-link>
                <span>{{ patient.name || 'Nowy pacjent' }}</span>
            </h2>
        </the-dashboard-heading>

        <the-dashboard-content>
            <patient-form
                @submit="savePatient">
            </patient-form>
        </the-dashboard-content>
    </div>

</template>


<script>

import {mapGetters} from 'vuex'

import TheDashboardHeading from 'Components/Dashboard/TheDashboardHeading'
import TheDashboardContent from 'Components/Dashboard/TheDashboardContent'
import PatientForm from 'Components/Patient/PatientForm'

export default {

    name: 'ViewPatientAdd',

    computed: {
        ...mapGetters(['patient'])
    },

    methods: {
        savePatient(after) {
            this.$store.dispatch('PATIENT_STORE').then(({data}) => {
                this.$alert.success('Dodawanie pacjenta', data.message)
                this.$router.push({name: 'PatientShow', params: {id: data.data.id}})
            }).catch((error) => {
                after()
                this.$alert.error('Dodawanie pacjenta', error.response.data.message)
            })
        }
    },

    mounted() {
        this.$store.dispatch('PATIENT_RESET')
    },

    components: {
        TheDashboardHeading,
        TheDashboardContent,
        PatientForm
    }

}

</script>
